/* eslint-disable import/first */
import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import css from './index.module.scss';

const Skelton = () => {
  return (
    <>
      <Box>
        <Skeleton count={1} className={css.skelton1} />
      </Box>
      <Box>
        <Skeleton count={1} className={css.skelton2} />
      </Box>
      <Box>
        <Skeleton count={1} className={css.skelton3} />
      </Box>
      <Box>
        <Skeleton count={1} className={css.skelton4} />
      </Box>
      <Box>
        <Skeleton count={1} className={css.skelton5} />
      </Box>
      <Box>
        <Skeleton count={1} className={css.skelton6} />
      </Box>
    </>
  );
};

export default Skelton;
